// firebase.js
// This file initializes the connection between the app and Firebase.
// It is imported by any component that needs to read or write data.
// Do not put any UI logic here — this is plumbing only.

import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

// Your Firebase project configuration keys.
// These are safe to be in client-side code — security is enforced by Firestore rules.
const firebaseConfig = {
  apiKey: "AIzaSyA3u_wHZRncn19CAe4pDoJ2SnVDldbo6gQ",
  authDomain: "the-golden-ticket-system.firebaseapp.com",
  projectId: "the-golden-ticket-system",
  storageBucket: "the-golden-ticket-system.firebasestorage.app",
  messagingSenderId: "138226743785",
  appId: "1:138226743785:web:35340eda414490f2f5f378"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export the services the app will use.
// Import these in any component that needs database, auth, or storage access.
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);